import React from "react";
import LegalPage from "./LegalPage";
import { LEGAL } from "./legalData";

const AvisoLegal = () => (
  <LegalPage title="Aviso Legal" lastUpdated={LEGAL.lastUpdated}>
    <h2>1. Datos identificativos del titular</h2>
    <p>
      En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad
      de la Información y de Comercio Electrónico (LSSI-CE), se informa de los datos del titular de
      este sitio web:
    </p>
    <ul>
      <li><strong>Titular:</strong> {LEGAL.razonSocial} (sociedad constituida en {LEGAL.paisRegistro})</li>
      <li><strong>Número de sociedad (Companies House):</strong> {LEGAL.numeroSociedad}</li>
      {LEGAL.vat && <li><strong>Nº de IVA/VAT:</strong> {LEGAL.vat}</li>}
      <li><strong>Domicilio social:</strong> {LEGAL.domicilio}</li>
      <li><strong>Dirección comercial:</strong> {LEGAL.domicilioComercial}</li>
      <li><strong>Correo electrónico:</strong> {LEGAL.email}</li>
      <li><strong>Sitio web:</strong> {LEGAL.webUrl}</li>
      <li><strong>Nombre comercial:</strong> {LEGAL.nombreComercial}</li>
    </ul>

    <h2>2. Objeto</h2>
    <p>
      El presente Aviso Legal regula el acceso y uso del sitio web {LEGAL.dominio} (en adelante, el
      "Sitio Web") y de la plataforma de gestión {LEGAL.nombreComercial} (en adelante, el "Servicio"),
      titularidad de {LEGAL.razonSocial}. El acceso al Sitio Web atribuye la condición de usuario e
      implica la aceptación de las condiciones aquí recogidas.
    </p>

    <h2>3. Condiciones de uso</h2>
    <p>
      El usuario se compromete a hacer un uso adecuado y lícito del Sitio Web y del Servicio conforme
      a la legislación aplicable, el presente Aviso Legal, los Términos y Condiciones y demás avisos e
      instrucciones. El usuario se abstendrá de utilizar el Sitio Web con fines ilícitos o que puedan
      dañar los derechos e intereses de terceros o el propio funcionamiento del Servicio.
    </p>

    <h2>4. Propiedad intelectual e industrial</h2>
    <p>
      Todos los contenidos del Sitio Web (textos, imágenes, marcas, logotipos, código fuente, diseño
      y software) son titularidad de {LEGAL.razonSocial} o de terceros que han autorizado su uso, y
      están protegidos por la normativa de propiedad intelectual e industrial. Queda prohibida su
      reproducción, distribución o transformación sin autorización expresa del titular.
    </p>

    <h2>5. Responsabilidad</h2>
    <p>
      {LEGAL.razonSocial} no se hace responsable de los daños o perjuicios derivados del uso indebido
      del Servicio por parte del usuario, ni de las interrupciones, virus o fallos que pudieran
      producirse por causas ajenas a su control razonable. El titular realizará esfuerzos razonables
      para garantizar la disponibilidad y continuidad del Servicio.
    </p>

    <h2>6. Enlaces</h2>
    <p>
      El Sitio Web puede contener enlaces a sitios de terceros. {LEGAL.razonSocial} no asume
      responsabilidad alguna sobre los contenidos ni las políticas de dichos sitios.
    </p>

    <h2>7. Legislación aplicable y jurisdicción</h2>
    <p>
      El presente Aviso Legal se rige por la legislación española. Para la resolución de cualquier
      controversia, las partes se someten a los Juzgados y Tribunales que correspondan conforme a
      Derecho.
    </p>
  </LegalPage>
);

export default AvisoLegal;
